import { FontTTHoves } from '@m/assets/fonts/tt-hoves/FontTTHoves';
import MaintenancePage from '@m/components/MaintenancePage/MaintenancePage';
import { MAINTENANCE_MODE } from '@m/config/FeatureFlags';
import { BrowserRouter } from 'react-router-dom';

import SharedProviders from './shared';

export interface ProvidersProps {
  children?: React.ReactNode;
  defaultTheme?: 'light' | 'dark';
}

export default function Providers({ children, defaultTheme = 'light' }: ProvidersProps) {
  return (
    <SharedProviders defaultTheme={defaultTheme}>
      <FontTTHoves />
      {MAINTENANCE_MODE ? <MaintenancePage /> : <BrowserRouter>{children}</BrowserRouter>}
    </SharedProviders>
  );
}
